import React from 'react'

const NotFound = () => {
  return (
    <div>404 NotFound AAA</div>
  )
}

export default NotFound